import {
  EmployeePromotionModel,
  useCreateEmployeePromotion,
  useUpdateEmployeePromotion,
} from 'api-hooks/employee';
import notification from 'components/common/notification';
import useDialog from 'hooks/use-dialog';
import React from 'react';

import EmployeePromotionForm from '../components/employee-promotion-form';

export default function useDialogPromotionForm(employeeId: string) {
  const createEmployeePromotion = useCreateEmployeePromotion(employeeId);
  const updateEmployeePromotion = useUpdateEmployeePromotion(employeeId);
  const dialog = useDialog();

  const onClickEmployeePromotion = React.useCallback(
    (promotion?: EmployeePromotionModel) => () => {
      dialog.showCustom({
        render(close) {
          return (
            <EmployeePromotionForm
              onClose={close}
              promotion={promotion}
              onSubmit={async (values) => {
                const result = promotion
                  ? await updateEmployeePromotion.mutateAsync({
                      id: promotion.id,
                      body: values,
                    })
                  : await createEmployeePromotion.mutateAsync(values);

                notification.success({
                  message: result.message,
                });

                close();
              }}
            />
          );
        },
      });
    },
    [createEmployeePromotion, dialog, updateEmployeePromotion],
  );

  return {
    onClickEmployeePromotion,
    createEmployeePromotion,
    updateEmployeePromotion,
  };
}
